export const MAILER_TRIGGERS = {
  early_voting_2wk: {
    label: '2 weeks before early voting',
    leadDays: 14,
  },
  early_voting_start: {
    label: 'Early voting starts',
    leadDays: 7,
  },
  registration_2wk: {
    label: 'Register — 2 weeks to deadline',
    leadDays: 14,
  },
  election_day: {
    label: 'Election day (arrives day before)',
    leadDays: 7,
  },
};

export const MAILER_PRICE = 2.0;
